import template from './add-outside-person.html';

export class AddOutsidePersonByPinController {
  constructor($log, $mdDialog, moment, PinCodeService) {
    'ngInject';
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.moment = moment;
    this.PinCodeService = PinCodeService;

    this.errorMessage = '';
    this.person = {};
  }

  $onChanges(changes) {
    if (changes.studentUserId) {
      this.person = {
        ...this.person,
        studentUserId: this.studentUserId
      };
    }

    if (changes.pinCode) {
      this.pinCode = {...this.pinCode};
      this.person = {
        ...this.person,
        PINCodeId: this.pinCode.PINCodeId,
        outsidePersonName: this.pinCode.outsidePersonName,
        outsidePersonLastName: this.pinCode.outsidePersonLastName
      };
    }
  }

  $onInit() {
    this.headerTitle = 'Dodawanie osoby uprawnionej do odbioru ucznia';
  }

  save(form) {
    form.$setSubmitted();
    if (form.$invalid) {
      return;
    }

    this.PinCodeService.authorizeOutsidePersonByPin(this.person)
      .then(response => {
        this.onSuccessAdd({result: response});
        this.nextStep();
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}

export const AddOutsidePersonByPin = {
  bindings: {
    headerTitle: '=',
    studentUserId: '<',
    pinCode: '<',
    nextStep: '&',
    onSuccessAdd: '&'
  },
  controller: AddOutsidePersonByPinController,
  template
};
